import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import RunSync from "./routes/RunSync";
import ExistingDataMapping from "./routes/ExistingDataMapping";
import SubjectMapping from "./routes/SubjectMapping";
import GradesMapping from "./routes/GradesMapping";
import TermMapping from "./routes/TermMapping";
import sisDataExclusion from "./routes/SisDataExclusion";
import ToddleDataExclusion from "./routes/ToddleDataExclusion";
import SyncSettings from "./routes/SyncSettings";
import StudentAlertMapping from "./routes/StudentAlertMapping";
import RolesPermissionsMapping from "./routes/RolesPermissionsMapping";

export default store => ({
  path: ":curriculum_id",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-schoolSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    RunSync(store),
    ExistingDataMapping(store),
    SubjectMapping(store),
    GradesMapping(store),
    TermMapping(store),
    sisDataExclusion(store),
    ToddleDataExclusion(store),
    SyncSettings(store),
    StudentAlertMapping(store),
    RolesPermissionsMapping(store),
  ],
});
